const PLG_CONFIG_ALLOWLIST = ['Default', 'Default Value', 'Style', 'Format', 'Required']
const PLG_DESIGN_ALLOWLIST = ['Background']

export const filterSettingsForPlg = (settings) => {
  const groups = []
  let currentGroup = { header: null, items: [] }

  for (const setting of settings) {
    if (setting.settingType === 'settingsLabel') {
      if (currentGroup.header || currentGroup.items.length) {
        groups.push(currentGroup)
      }
      currentGroup = { header: setting, section: setting.label, items: [] }
    } else {
      currentGroup.items.push(setting)
    }
  }
  if (currentGroup.header || currentGroup.items.length) {
    groups.push(currentGroup)
  }

  const result = []
  for (const group of groups) {
    if (!group.header) {
      // Pre-section items (Label, Type) — always keep
      result.push(...group.items)
    } else if (group.section === 'Config') {
      const kept = group.items.filter(s => PLG_CONFIG_ALLOWLIST.includes(s.label))
      if (kept.length) {
        result.push(group.header, ...kept)
      }
    } else if (group.section === 'Design') {
      const kept = group.items.filter(s => PLG_DESIGN_ALLOWLIST.includes(s.label))
      if (kept.length) {
        result.push(group.header, ...kept)
      }
    }
  }

  return result
}
